import {
    LaunchpadItem,
    OperatorTask,
    TaskStatus,
} from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';
import collectiveApi from 'modules/common/collectiveApi';
import { BusinessVerificationTaskName } from 'modules/Onboarding/BusinessVerificationFlow/constants';

/**
 * These tasks are displayed as completed in the launchpad, but they are not actually completed
 * as there are processes running in the background that are not yet complete.
 * like AOO being pulled from middesk.
 */
const hardcodeAsCompletedTaskNames: string[] = [
    BusinessVerificationTaskName.BUSINESS_VERIFICATION_UPLOAD_ARTICLES_OF_ORGANIZATION,
    BusinessVerificationTaskName.BUSINESS_VERIFICATION_UPLOAD_ARTICLES_OF_ORGANIZATION_MIDDESK,
];

export default async function getOperatorTasks(taskNames: string[], skipHardcodedStatus = false) {
    const { data } = await collectiveApi.get<OperatorTask[]>(`/v2/members/tasks/`, {
        params: {
            task_template_names: taskNames.join(','),
        },
    });

    const tasks: Record<string, Partial<LaunchpadItem>> = Object.fromEntries(
        data
            .filter((task) => {
                const isIncluded = taskNames.includes(task.task_template.name);
                return isIncluded;
            })
            .map((task) => {
                let ctaUrl = null;
                if (task.task_template.resources.cta_url) {
                    ctaUrl = task.task_template.resources.cta_url;
                }
                if (task.context.cta_url) {
                    ctaUrl = task.context.cta_url;
                }
                if (ctaUrl) {
                    ctaUrl = `${ctaUrl}?task_id=${task.id}`;
                }

                const isHardcodedAsCompletedTask =
                    !skipHardcodedStatus && hardcodeAsCompletedTaskNames.includes(task.task_template.name);
                const finalStatus = isHardcodedAsCompletedTask ? TaskStatus.COMPLETED : task.status;

                return [
                    task.task_template.name,
                    {
                        id: task.id,
                        name: task.task_template.display_name,
                        description: task.task_template.instructions,
                        status: finalStatus,
                        dependency: [],
                        subtasks: [],
                        cta_url: ctaUrl,
                        is_cta_external: false,
                        context: task.context,
                    },
                ];
            })
    );

    return tasks;
}
